import { render, staticRenderFns } from "./message-timestamp.vue?vue&type=template&id=0b9e1299&scoped=true"
import script from "./message-timestamp.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-timestamp.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./message-timestamp.vue?vue&type=style&index=0&id=0b9e1299&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9e1299",
  null
  
)

export default component.exports